const players = document.querySelectorAll("[data-video-with-title]")

const fitIframeToCover = (iframe, wrap, videoWidth, videoHeight) => {
    if (!iframe || !wrap || !videoWidth || !videoHeight) {
        return
    }

    const wrapWidth = wrap.clientWidth
    const wrapHeight = wrap.clientHeight

    if (!wrapWidth || !wrapHeight) {
        return
    }

    const wrapRatio = wrapWidth / wrapHeight
    const videoRatio = videoWidth / videoHeight
    let scale = 1

    if (videoRatio > wrapRatio) {
        scale = videoRatio / wrapRatio
    } else if (videoRatio < wrapRatio) {
        scale = wrapRatio / videoRatio
    }

    iframe.style.width = `${wrapWidth}px`
    iframe.style.height = `${wrapHeight}px`
    iframe.style.transform =
        scale > 1
            ? `translate(-50%, -50%) scale(${scale})`
            : "translate(-50%, -50%)"
}

const fetchVimeoDimensions = async (videoId) => {
    try {
        const response = await fetch(
            `https://vimeo.com/api/oembed.json?url=https://vimeo.com/${videoId}`
        )

        if (!response.ok) {
            return null
        }

        const data = await response.json()

        if (data.thumbnail_width && data.thumbnail_height) {
            return {
                width: data.thumbnail_width,
                height: data.thumbnail_height,
            }
        }

        if (data.width && data.height) {
            return {
                width: data.width,
                height: data.height,
            }
        }
    } catch {
        return null
    }

    return null
}

const fetchYouTubeDimensions = async (videoId) => {
    try {
        const response = await fetch(
            `https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${videoId}&format=json`
        )

        if (!response.ok) {
            return null
        }

        const data = await response.json()

        if (data.thumbnail_width && data.thumbnail_height) {
            return {
                width: data.thumbnail_width,
                height: data.thumbnail_height,
            }
        }
    } catch {
        return null
    }

    return null
}

players.forEach((player) => {
    const provider = player.dataset.videoProvider
    const videoId = player.dataset.videoId
    const playButton = player.querySelector("[data-video-play]")
    const muteButton = player.querySelector("[data-video-mute]")
    const poster = player.querySelector("[data-video-poster]")
    const iframeWrap = player.querySelector("[data-video-iframe-wrap]")
    const muteIcon = player.querySelector("[data-mute-icon]")
    const unmuteIcon = player.querySelector("[data-unmute-icon]")
    const playIcon = player.querySelector("[data-play-icon]")
    const pauseIcon = player.querySelector("[data-pause-icon]")

    if (!provider || !videoId || !playButton || !iframeWrap) {
        return
    }

    const hasPoster = player.dataset.hasPoster === "1"
    const isVimeo = provider === "vimeo"
    const vimeoOrigin = "https://player.vimeo.com"
    const vimeoPlayerId = `video-with-title-${videoId}`

    let isPlaying = false
    let isMuted = true
    let iframe = null
    let vimeoReady = false
    let videoDimensions = { width: 16, height: 9 }
    let dimensionsLoaded = false

    const loadVideoDimensions = async () => {
        if (dimensionsLoaded) {
            return
        }

        const dimensions = isVimeo
            ? await fetchVimeoDimensions(videoId)
            : await fetchYouTubeDimensions(videoId)

        dimensionsLoaded = true

        if (dimensions) {
            videoDimensions = dimensions
        }

        syncIframeFit()
    }

    loadVideoDimensions()

    const syncIframeFit = () => {
        fitIframeToCover(
            iframe,
            iframeWrap,
            videoDimensions.width,
            videoDimensions.height
        )
    }

    const onResize = () => {
        syncIframeFit()
    }

    window.addEventListener("resize", onResize)

    const getEmbedUrl = (autoplay = false) => {
        if (provider === "youtube") {
            const params = new URLSearchParams({
                enablejsapi: "1",
                origin: window.location.origin,
                autoplay: autoplay ? "1" : "0",
                mute: isMuted ? "1" : "0",
                controls: "0",
                rel: "0",
                modestbranding: "1",
                iv_load_policy: "3",
                disablekb: "1",
            })

            return `https://www.youtube.com/embed/${videoId}?${params.toString()}`
        }

        if (isVimeo) {
            const params = new URLSearchParams({
                api: "1",
                player_id: vimeoPlayerId,
                autoplay: autoplay ? "1" : "0",
                muted: isMuted ? "1" : "0",
                controls: "0",
                title: "0",
                byline: "0",
                portrait: "0",
            })

            return `${vimeoOrigin}/video/${videoId}?${params.toString()}`
        }

        return ""
    }

    const getIframe = () => iframe

    const postYouTubeCommand = (func, args = "") => {
        const currentIframe = getIframe()

        if (!currentIframe) {
            return
        }

        currentIframe.contentWindow.postMessage(
            JSON.stringify({
                event: "command",
                func,
                args,
            }),
            "*"
        )
    }

    const postVimeoCommand = (method, value) => {
        const currentIframe = getIframe()

        if (!currentIframe || !vimeoReady) {
            return
        }

        const message = { method }

        if (value !== undefined) {
            message.value = value
        }

        currentIframe.contentWindow.postMessage(
            JSON.stringify(message),
            vimeoOrigin
        )
    }

    const syncVimeoVolume = () => {
        postVimeoCommand("setVolume", isMuted ? 0 : 1)
    }

    const onVimeoMessage = (event) => {
        if (event.origin !== vimeoOrigin || !iframe || event.source !== iframe.contentWindow) {
            return
        }

        let data = event.data

        if (typeof data === "string") {
            try {
                data = JSON.parse(data)
            } catch {
                return
            }
        }

        if (data.event === "ready") {
            vimeoReady = true
            syncVimeoVolume()
            syncIframeFit()
            window.setTimeout(syncIframeFit, 100)
            window.setTimeout(syncIframeFit, 500)
        }
    }

    window.addEventListener("message", onVimeoMessage)

    const updatePlayState = () => {
        player.classList.toggle("is-playing", isPlaying)
        playButton.setAttribute(
            "aria-label",
            isPlaying ? "Video pauzeren" : "Video afspelen"
        )

        if (playIcon) {
            playIcon.hidden = isPlaying
        }

        if (pauseIcon) {
            pauseIcon.hidden = !isPlaying
        }
    }

    const updateMuteState = () => {
        if (!muteButton) {
            return
        }

        muteButton.setAttribute(
            "aria-label",
            isMuted ? "Geluid aan" : "Geluid uit"
        )

        if (muteIcon) {
            muteIcon.hidden = !isMuted
        }

        if (unmuteIcon) {
            unmuteIcon.hidden = isMuted
        }
    }

    const playVideo = () => {
        if (provider === "youtube") {
            postYouTubeCommand("playVideo")
        } else {
            postVimeoCommand("play")
        }

        isPlaying = true
        updatePlayState()
    }

    const pauseVideo = () => {
        if (provider === "youtube") {
            postYouTubeCommand("pauseVideo")
        } else {
            postVimeoCommand("pause")
        }

        isPlaying = false
        updatePlayState()
    }

    const setMuted = (muted) => {
        isMuted = muted

        if (provider === "youtube") {
            postYouTubeCommand(muted ? "mute" : "unMute")
        } else if (vimeoReady) {
            syncVimeoVolume()
        }

        updateMuteState()
    }

    const initIframe = (autoplay = false) =>
        new Promise((resolve) => {
            if (iframe) {
                resolve()
                return
            }

            const embedUrl = getEmbedUrl(autoplay)

            if (!embedUrl) {
                resolve()
                return
            }

            iframeWrap.hidden = false

            if (poster) {
                poster.hidden = true
            }

            iframe = document.createElement("iframe")
            iframe.className = "video-with-title__iframe"
            iframe.id = isVimeo ? vimeoPlayerId : ""
            iframe.src = embedUrl
            iframe.title = "Video"
            iframe.setAttribute("frameborder", "0")
            iframe.setAttribute(
                "allow",
                "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            )
            iframe.setAttribute(
                "referrerpolicy",
                "strict-origin-when-cross-origin"
            )
            iframe.allowFullscreen = true

            iframe.addEventListener("load", () => {
                syncIframeFit()
                window.setTimeout(() => {
                    syncIframeFit()
                    resolve()
                }, isVimeo ? 500 : 300)
            })

            iframeWrap.appendChild(iframe)
            syncIframeFit()
        })

    playButton.addEventListener("click", async () => {
        if (!iframe) {
            await loadVideoDimensions()
            await initIframe(true)
            playVideo()
            return
        }

        if (isPlaying) {
            pauseVideo()
        } else {
            playVideo()
        }
    })

    if (!hasPoster) {
        loadVideoDimensions().then(() => initIframe(false))
    }

    if (muteButton) {
        muteButton.addEventListener("click", (event) => {
            event.stopPropagation()

            if (!iframe) {
                isMuted = !isMuted
                updateMuteState()
                return
            }

            setMuted(!isMuted)
        })

        updateMuteState()
    }
})
